module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "epigraph ParaOverride-3",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("A day and another day and the day before, and the library with the big boys in the shelves, old Dreiser, old Mencken, all the boys down there, and I went to see them, Hya Dreiser, Hya Mencken, Hya, hya: there’s a place for me, too, and it begins with B, in the B shelf, Arturo Bandini, make way for Arturo Bandini, his slot for his book, and I sat at the table and just looked at the place where my book would be, right there close to Arnold Bennett; not much that Arnold Bennett, but I’d be there to sort of bolster up the B’s, old Arturo Bandini … ")]), _vm._v(" "), _c('p', {
    staticClass: "epigraph-right",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("John Fante, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ask the Dust")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19038f18","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RonCarlson-28.vue
// module id = 75
// module chunks = 0